'use client'

import {
  Stack,
  Flex,
  Button,
  Text,
  useBreakpointValue,
  Link,
  Image,
  Box,
  Heading,
} from '@chakra-ui/react'
import backgroundImage from './bg2.jpeg'
import ufLogo from './uf_logo.png'
import ll from './lyquor-labs.png'

export default function BackgroundImage() {
  return (
    <Box
      w="100vw"
      h="100vh"
      minH="600px"
      position="relative"
      bgImage={`url(${backgroundImage})`}
      bgSize="cover"
      bgPosition="center"
      bgRepeat="no-repeat"
      overflow="hidden"
    >
      {/* Gradient Overlay */}
      <Box
        position="absolute"
        top={0}
        left={0}
        w="100%"
        h="100%"
        bgGradient="linear(to-b, rgba(30,58,138,0.7) 0%, rgba(255,255,255,0.7) 100%)"
        zIndex={1}
      />

      {/* Glassmorphism Card */}
      <Flex
        zIndex={2}
        position="relative"
        direction="column"
        align="center"
        justify="center"
        w="full"
        h="100vh"
        px={useBreakpointValue({ base: 4, md: 8 })}
      >
        <Box
          bg="rgba(255,255,255,0.7)"
          boxShadow="0 8px 32px 0 rgba(31, 38, 135, 0.37)"
          backdropFilter="blur(8px)"
          borderRadius="2xl"
          p={{ base: 6, md: 10 }}
          maxW="2xl"
          textAlign="center"
        >
          <Heading
            as="h1"
            fontSize={{ base: '3xl', md: '5xl' }}
            fontWeight="extrabold"
            color="blue.800"
            mb={4}
            letterSpacing="tight"
            textShadow="0 4px 24px rgba(0,0,0,0.12)"
            lineHeight={1.1}
          >
            FBC '25 Summit
          </Heading>
          <Text
            color="gray.700"
            fontWeight={500}
            fontSize={{ base: 'md', md: 'xl' }}
            mb={2}
          >
            Hosted by the{' '}
            <Link
              href="https://fiftech.cs.ucsb.edu/"
              target="_blank"
              rel="noopener noreferrer"
              color="blue.600"
              fontWeight="bold"
              textDecoration="underline"
            >
              Fftech Lab
            </Link>{' '}
            and{' '}
            <Link
              href="https://www.linkedin.com/company/blockchainatucsb/"
              target="_blank"
              rel="noopener noreferrer"
              color="blue.600"
              fontWeight="bold"
              textDecoration="underline"
            >
              Blockchain@UCSB
            </Link>
          </Text>
          <Text
            color="gray.800"
            fontWeight={700}
            fontSize={{ base: 'md', md: 'xl' }}
            mt={2}
            mb={4}
          >
            Sponsored by
          </Text>
          <Flex
            direction="row"
            justify="center"
            align="center"
            gap={8}
            mb={4}
          >
            <Image
              src={ufLogo}
              alt="Uniswap Foundation Logo"
              h={useBreakpointValue({ base: '50px', md: '70px' })}
              w="auto"
              objectFit="contain"
              // bg="white"
              p={2}
            />
            <Image
              src={ll}
              alt="Lyquor Labs Logo"
              h={useBreakpointValue({ base: '50px', md: '70px' })}
              w="auto"
              objectFit="contain"
              p={2}
            />
          </Flex>
          <Text
            color="blue.800"
            fontWeight={700}
            fontSize={{ base: 'md', md: 'xl' }}
            mb={2}
          >
            Santa Barbara | UCSB Campus | May 17, 2025 | Henley Hall
          </Text>
          <Link
            href="https://maps.app.goo.gl/V1bfXKRTHEaxirMg9"
            color="blue.500"
            fontWeight="bold"
            isExternal
            fontSize="md"
            mb={6}
            display="inline-block"
            _hover={{ textDecoration: "underline", color: "blue.700" }}
          >
            Directions to Henley Hall
          </Link>
          <Stack
            direction={{ base: 'column', sm: 'row' }}
            justify="center"
            spacing={4}
            w="full"
          >
            <Link href="https://forms.gle/sLiEcrU5t1abLR1B8" target="_blank">
              <Button
                bgGradient="linear(to-r, blue.400, blue.600)"
                rounded="full"
                color="white"
                _hover={{ bgGradient: 'linear(to-r, blue.600, blue.800)', transform: 'translateY(-2px)' }}
                boxShadow="md"
                size="lg"
                px={8}
                fontWeight="bold"
              >
                Register
              </Button>
            </Link>
            <Link href="mailto: team@blockchainucsb.com" target="_blank">
              <Button
                bgGradient="linear(to-r, teal.400, teal.600)"
                rounded="full"
                color="white"
                _hover={{ bgGradient: 'linear(to-r, teal.600, teal.800)', transform: 'translateY(-2px)' }}
                boxShadow="md"
                size="lg"
                px={8}
                fontWeight="bold"
              >
                Contact Us
              </Button>
            </Link>
          </Stack>
        </Box>
      </Flex>
    </Box>
  )
}
